import { render, staticRenderFns } from "./RecoveryApp.vue?vue&type=template&id=14a09cc7&scoped=true&"
import script from "./RecoveryApp.vue?vue&type=script&lang=ts&"
export * from "./RecoveryApp.vue?vue&type=script&lang=ts&"
import style0 from "./RecoveryApp.vue?vue&type=style&index=0&id=14a09cc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a09cc7",
  null
  
)

export default component.exports